import React from "react";
import PropTypes from "prop-types";
import BondBillingInformationBase from "../../../../features/bonds/shared/components/BondBillingInformationBase";
import { getBillingSurfaceConfig } from "../../../../features/bonds/shared/billingSurfaceConfig";
import { GoogleAutoComplete, LabeledCreatableSelect } from "../../../../features/bonds/shared/widgets";
import { PLACES_TYPES_GEOCODE } from "../../../../globals/components/forms/GoogleAutoCompleteField";

const BillingGoogleAutoComplete = (props) => (
  <GoogleAutoComplete placesTypes={PLACES_TYPES_GEOCODE} {...props} />
);

export const BillingInformationForm = ({ data, updateData, globalData, isGuest }) => (
  <BondBillingInformationBase
    cfg={getBillingSurfaceConfig("creation")}
    GoogleAutoComplete={BillingGoogleAutoComplete}
    LabeledCreatableSelect={LabeledCreatableSelect}
    data={data}
    updateData={updateData}
    globalData={globalData}
    isGuest={isGuest}
  />
);

BillingInformationForm.propTypes = {
  data: PropTypes.object.isRequired,
  updateData: PropTypes.func.isRequired,
  globalData: PropTypes.object.isRequired,
  isGuest: PropTypes.bool,
};
